const calendarDate = (iso, timeZone) => {
  if (!iso) return "unknown";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "unknown";
  try {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: timeZone || "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  } catch (_err) {
    return date.toISOString().slice(0, 10);
  }
};

const utcStamp = (iso) => {
  const date = iso ? new Date(iso) : new Date();
  const instant = Number.isNaN(date.getTime()) ? new Date() : date;
  return instant
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\.\d{3}Z$/, "Z");
};

export const buildExceptionsExportFileName = (report, extension) => {
  const filters = report?.filters || {};
  const start = calendarDate(filters.start, filters.timezone);
  const end = calendarDate(filters.end, filters.timezone);
  const generated = utcStamp(report?.generated_at);
  const ext = String(extension || "html").replace(/^\./, "");
  return `exceptions-report_${start}_to_${end}_generated-${generated}.${ext}`;
};
